// extracted by mini-css-extract-plugin
module.exports = {"manageCookiesBtn":"styles_manageCookiesBtn__cpyNH"};